import { api } from "@/lib/api";
import { getWatchlist } from "@/lib/watchlist";

const KEY = "gmscan_wallet_session";

export const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const clearSession = () => localStorage.removeItem(KEY);

const authHeaders = () => {
  const s = getSession();
  return s?.token ? { Authorization: `Bearer ${s.token}` } : null;
};

export const connectWallet = async () => {
  const eth = window.ethereum;
  if (!eth) throw new Error("No wallet extension found. Please install MetaMask.");
  const accounts = await eth.request({ method: "eth_requestAccounts", params: [] });
  const address = accounts[0];
  const { data: n } = await api.get("/auth/nonce", { params: { address } });
  const message = `GMScan wants you to sign in with your wallet.\n\nAddress: ${address}\nNonce: ${n.nonce}\n\nThis signature is free and does not send a transaction.`;
  const signature = await eth.request({ method: "personal_sign", params: [message, address] });
  const { data } = await api.post("/auth/verify", { address, message, signature });
  localStorage.setItem(KEY, JSON.stringify({ address: data.address, token: data.token }));
  return data.address;
};

export const pullAndMergeWatchlist = async () => {
  const h = authHeaders();
  if (!h) return null;
  try {
    const { data } = await api.get("/watchlist", { headers: h });
    const seen = new Set();
    const merged = [...getWatchlist(), ...(data.items || [])].filter((i) => {
      const k = String(i.value || "").toLowerCase();
      if (!k || seen.has(k)) return false;
      seen.add(k);
      return true;
    });
    localStorage.setItem("gmscan_watchlist", JSON.stringify(merged));
    await api.put("/watchlist", { items: merged }, { headers: h });
    return merged;
  } catch (e) {
    if (e?.response?.status === 401) clearSession();
    throw e;
  }
};

let pushTimer;
export const schedulePush = () => {
  const h = authHeaders();
  if (!h) return;
  clearTimeout(pushTimer);
  pushTimer = setTimeout(() => {
    api.put("/watchlist", { items: getWatchlist() }, { headers: h }).catch((e) => {
      if (e?.response?.status === 401) clearSession();
    });
  }, 800);
};

if (typeof window !== "undefined") {
  window.addEventListener("gmscan:watchlist-changed", schedulePush);
}
